import { render } from "./headPiece.vue?vue&type=template&id=7f8e409a&scoped=true"
import script from "./headPiece.vue?vue&type=script&lang=js"
export * from "./headPiece.vue?vue&type=script&lang=js"

import "./headPiece.vue?vue&type=style&index=0&id=7f8e409a&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8e409a"]])

export default __exports__